import React from 'react';
import ReactDOM from 'react-dom';
import initData from 'packages/init-data';
import logger from 'packages/logger';
import Sticky from 'react-stickynode';
import { Connected, SiteHeader } from 'components';
const el = document.querySelector('[data-site-header-slim]');

if (el && initData) {
    const cartItemCount = el.getAttribute('data-cart-item-count');
    const cartSum = el.getAttribute('data-cart-sum');
    const ConnectedHeader = Connected(SiteHeader);
    const hasStickyHeader = !initData.pageName.includes('MyTradera');
    try {
        ReactDOM.render(
            <Sticky
                enabled={hasStickyHeader}
                top={0}
                enableTransforms={true}
                activeClass="slim-header--sticky">
                <ConnectedHeader
                    {...{
                        initData: initData,
                        cartItems: cartItemCount,
                        cartSum: cartSum
                    }}
                    events={{ 'data:navigation:after-page-load': 'initData' }}
                />
            </Sticky>,
            el
        );
    } catch (e) {
        logger(e);
    }
}



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/navigation/main-navigation.js